import { Popover, PopoverProps } from 'antd';
import React, { forwardRef } from 'react';
import styles from './squad-picker.module.css';

interface SquadPopoverProps extends Omit<PopoverProps, 'onVisibleChange'> {
  onOpen?: () => void;
  onClose?: () => void;
  isControlled?: boolean;
}
const EMPTY_HANDLER = () => {};

export const SquadPopover = forwardRef((props: SquadPopoverProps, ref) => {
  const { onClose, onOpen, isControlled, ...rest } = props;
  const handleVisibleChange = (isVisible: boolean) => {
    if (isVisible) {
      if (onOpen) {
        onOpen();
      }
    } else if (onClose) {
      onClose();
    }
  };

  return (
    <Popover
      ref={ref}
      trigger={['click']}
      placement="bottomRight"
      overlayClassName={styles.popover}
      onVisibleChange={isControlled ? EMPTY_HANDLER : handleVisibleChange}
      {...rest}
    />
  );
});
